import React from 'react';
import { Button } from 'antd';
import { ReactComponent as SuccessIcon } from '@/views/account/assets/icons/result-success.svg';
import { ReactComponent as FailedIcon } from '@/views/account/assets/icons/result-failed.svg';
import { useTranslation } from 'react-i18next';
import '@/views/account/assets/resultModal.scss';

const ResultModalRender = ({ title, subTitle, status, btnText, onClose }) => {
  const { t } = useTranslation(['common']);
  return (
    <div className='result-modal d-flex align-items-center justify-content-center flex-column'>
      {title ? (
        <h4 className='title fw-bold mb-2 text-center'>{title}</h4>
      ) : null}
      {subTitle ? (
        <p className='subTitle text-center text-muted'>{subTitle}</p>
      ) : null}
      {status === 'success' ? (
        <SuccessIcon className='mb-3 mb-md-5' />
      ) : (
        <FailedIcon className='mb-3 mb-md-5' />
      )}
      <Button className='ok-btn' type='primary' size='large' onClick={onClose}>
        {btnText ? btnText : t('okBtn')}
      </Button>
    </div>
  );
};

export default ResultModalRender;
